<!--
 * @Author: your name
 * @Date: 2021-10-18 18:04:29
 * @LastEditTime: 2021-10-18 18:04:50
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \rightcloud-console\src\views\429.vue
-->
<template>
    <div class="error429">
        <errorItem :data="data">
            <img src="@/assets/images/429.jpg">
        </errorItem>
    </div>
</template>

<script>
import errorItem from '@/views/components/basic/erroritem'
export default {
    name: 'Error429',
    data () {
        return {
            data: {
                errorCode: 429,
                ms: '抱歉，无法访问此网页...',
                ts: '该IP未被允许访问或疑似有攻击行为！请联系管理员！'
            }
        }
    },
    components: { errorItem }
}
</script>
<style lang="less">
</style>
